// extracted by mini-css-extract-plugin
module.exports = {"warper":"RecordFailComponent_warper_2f0lU","img":"RecordFailComponent_img_ULHtb","footer":"RecordFailComponent_footer_1hKpA"};